import React, { Suspense } from "react";
import Box from "./elements_responsive_static/Box";
import Section from "./elements_responsive_static/Section";
import Header from "./elements_responsive_static/Header";
import Img from "./elements_responsive_static/Img";
import HtmlText from "./elements_responsive_static/HtmlText";
import Button from "./elements_responsive_static/Button";
import Text from "./elements_responsive_static/Text";
import Blank from "./elements_responsive_static/Blank";
import List from "./elements_responsive_static/List";
import Divider from "./elements_responsive_static/Divider";
import QIcon from "./elements_responsive_static/QIcon";
import Video from "./elements_responsive_static/Video";
import SlidingText from "./elements_responsive_static/SlidingText";
import NavMenu from "./elements_responsive_static/custom/NavMenu";
// const NavMenu = dynamic(
//     () => import("./elements_responsive_static/custom/NavMenu"),
//     { ssr: false }
// );
import VerticalMenu from "./elements_responsive_static/custom/VerticalMenu";
import TypingText from "./elements_responsive_static/custom/TypingText";
import IconList from "./elements_responsive_static/custom/IconList";
import ImageCarousel from "./elements_responsive_static/custom/ImageCarousel";
import ContactForm from "./elements_responsive_static/form/ContactForm";
import MapView from "./elements_responsive_static/custom/MapView";
import AudioPlayer from "./elements_responsive_static/custom/AudioPlayer";
import Gallery from "./elements_responsive_static/custom/Gallery";
import LoopBuilder from "./elements_responsive_static/loopbuilder/LoopBuilder";
import Rating from "./elements_responsive_static/custom/Rating";
import SocialIcons from "./elements_responsive_static/custom/SocialIcons";
import PDFViewer from "./elements_responsive_static/custom/PDFViewer";
import Tabs from "./elements_responsive_static/tabs/Tabs";
import QTable from "./elements_responsive_static/table/QTable";
// import AdditionalElement from "../../../store/AdditionalElement";
// Charts
import BarChart from "./elements_responsive_static/charts/BarChart";
import LineChart from "./elements_responsive_static/charts/LineChart";
import QFilters from "./elements_responsive_static/filters/QFilters";
// import dynamic from "next/dynamic";
import QSearch from "./elements_responsive_static/filters/QSearch";
import Form from "./elements_responsive_static/form/Form";
import PopupForm from "./elements_responsive_static/form/PopupForm";
import QPagination from "./elements_responsive_static/filters/QPagination";
import Breadcrumb from "./elements_responsive_static/custom/Breadcrumb";
import QiFrame from "./elements_responsive_static/embed/QiFrame";

function AdditionalElement() {
	return <p>Additional element on hold</p>
}

// props: {id, db, gs}
function Element(props) {
	const data = props.db[props.id];

	if (!data) {
		return <p>Nothing found</p>;
	}

	switch (data.type) {
		case "section":
			return <Section {...props} />;
		case "box":
			return <Box {...props} />;
		case "header":
			return <Header {...props} />;
		case "p":
			return <Text {...props} />;
		case "img":
			return <Img {...props} />;
		case "htmltext":
			return <HtmlText {...props} />;
		case "button":
			return <Button {...props} />;
		case "blank":
			return <Blank {...props} />;
		case "list":
			return <List {...props} />;
		case "divider":
			return <Divider {...props} />;
		case "icon":
			return <QIcon {...props} />;
		case "video":
			return <Video {...props} />;
		case "slidingText":
			return <SlidingText {...props} />;
		case "navMenu":
			return <NavMenu {...props} />;
		// return <h2>Nav Menu</h2>;
		case "verticalMenu":
			return <VerticalMenu {...props} />;
		case "typingText":
			return <TypingText {...props} />;
		case "iconList":
			return <IconList {...props} />;
		case "imageCarousel":
			return <ImageCarousel {...props} />;
		case "formContact":
			return <ContactForm {...props} />;
		case "map":
			return <MapView {...props} />;
		case "audioPlayer":
			return <AudioPlayer {...props} />;
		case "gallery":
			return <Gallery {...props} />;
		case "loopBuilder":
			return <LoopBuilder {...props} />;
		case "rating":
			return <Rating {...props} />;
		case "socialIcons":
			return <SocialIcons {...props} />;
		case "pdfViewer":
			return <PDFViewer {...props} />;
		case "tabs":
			return <Tabs {...props} />;
		case "table":
			return <QTable {...props} />;
		case "barChart":
			return <BarChart {...props} />;
		case "lineChart":
			return <LineChart {...props} />;
		case "filters":
			return <QFilters {...props} />;
		case "search":
			return <QSearch {...props} />;
		case "form":
			return <Form {...props} />;
		case "popupForm":
			return <PopupForm {...props} />;
		case "pagination":
			return <QPagination {...props} />;
		case "breadcrumb":
			return <Breadcrumb {...props} />;
		case "iframe":
			return <QiFrame {...props} />;
		default:
			// return <h3>Element not found: {data.type}</h3>;
			return <AdditionalElement type={data.type} eprops={props} />;
	}
}

export default Element;
